// Third-party imports
import $ from 'jquery';

// Local imports
import * as constant from '../global/constant.js';
import { formatValue } from '../global/validate_price.js';

// global is expected to be the window object when run in a browser
export function initialize(global) {
    let amountInputs = $('.basket-items .js-amount');
    let frequencyInput = $('.basket-items .js-frequency');
    let removeInput = $('.js-removeSponsorship');
    let form = $('.basket-items form');
    //The below code is added to populate the correct quantity (it should add $1 instead it should be the actual amount entered  by donor) 
    //for donation type products which will add from recommended section 
    let recommDonationAmtFields = global.document.querySelectorAll('.field-input.field--right','.field-input.field--left');    
    //field-input js-frequency
    for (let el of recommDonationAmtFields) {
        el.addEventListener('blur', event => {
            var amount = el.value; 
            let eleQuantity = el.dataset.productid;
            //Get the quantity hidden field from form post for recommended section (card-recommended.liquid page)
            var quantity = document.getElementById(eleQuantity) ;         
            console.log('quantity value:'+amount)
            //Update the quantity as amount field, because we do not want show the discounted price in checkout in checkout extensibility page
            quantity.value = amount;
            global.window.reload();
        });
    }
    let updatefunc = event => {
        update(global, event);
    };
    amountInputs.on('keypress', ev => {
        if (ev.key === 'Enter') {
            updatefunc(ev);
        }
    });
    amountInputs.on('focusout', ev => {
        updatefunc(ev);
    });
    frequencyInput.on('change', updatefunc);
    removeInput.on('click', event => {
        remove(global, event);
    });

    // Disable form submission when pressing the Enter key for amountInput since
    // updateDonation below will reload the cart
    form.on('submit', event => {
        event.preventDefault();
    });
    removeRecoSection();
    validateIfAmountHasError();
}

function addProductsToCart(global,variantID) {
    console.log("#########Yes inside giving card page#########");
    let url = '/cart/add.js';
    $.ajax({
        type: 'POST',
        url: url,
        dataType: 'json',
        data: {
            quantity: 50,
            id: variantID
        },
    })
        .then(() => {
            global.location.reload();
        })
        .catch(data => {
            let err = {
                msg: `POST failed for url: ${url}`,
                data,
            };
            throw err;
        });
}

// Check if any amount input field has a value in data-has-error.
// If the value is true, then the page has reloaded with the amount in the card
// as 0, and has errored the cart
function validateIfAmountHasError() {
    $('.basket-items .js-amount').each((index, element) => {
        if ($(element).data('hasError') === true) {
            // We manually run a parsley validate in order to get an error message
            $(element)
                .parsley()
                .validate();
        }
    });
}

function update(global, event) {
    if (validate(event)) {
        let props = getProps(event);
        if (!changed(props)) {
            return;
        }
        if (props.type === 'Donation') {
            updateDonation(global, props, event.currentTarget);
        } else if (
            props.type === 'Child Sponsorship' ||
            props.type === 'Child Sponsorship Special Event'
        ) {
            updateSponsorship(global, props);
        } else if (props.type === 'Topup') {
            updateTopup(global, props);
        }
    }
}

function validate(event) {
    if ($(event.target).is('form')) {
        let ret = $(event.target)
            .parsley()
            .validate();
        return ret;
    } else {
        let ret = $(event.target)
            .closest('form')
            .parsley()
            .validate();
        return ret;
    }
}

// global is expected to be the window object when run in a browser
function updateDonation(global, props, from) {
    let inputValue = parseFloat(formatValue(props.amount));

    if (inputValue < 10) {
        return;
    }

    let hidden_fields = $(from)
        .closest('form')
        .find('.js-hiddenFields');
    let onetime = hidden_fields.children('input[name=des_code_one]').val();
    let monthly = hidden_fields.children('input[name=des_code_monthly]').val();
    let desReplace;

    if (props.frequency !== 'SG') {
        desReplace = monthly;
    }
    if (props.frequency === 'SG') {
        desReplace = onetime;
    }
    let url =
        `/cart/change?line=${props.lineNumber}` +
        `&quantity=${inputValue}` +
        `&properties[_amount]=${inputValue}` +
        `&properties[_type]=${props.frequency}` +
        `&properties[_des_code]=${desReplace}`;
    global.location = addOriginalPropsToURL(props.original, url);
}

// global is expected to be the window object when run in a browser
function updateSponsorship(global, props) {
    let total = parseFloat(props.amount) + parseFloat(props.minAmount);
    let newurl =
        `/cart/change?line=${props.lineNumber}` +
        `&properties[_amount]=${total}` +
        `&properties[_type]=${props.frequency}` +
        `&properties[_topupAmount]=${props.amount}`;
    global.location = addOriginalPropsToURL(props.original, newurl);
}

function updateTopup(global, props) {
    if (props.lineNumber === 'new') {
        let variantid = constant.get_variantid(
            global,
            constant.VariantKind.Topup
        );
        window.location =
            `/cart/add?id=${variantid}` +
            `&properties[_childid]=${props.childid}` +
            `&properties[_amount]=${props.amount}` +
            '&properties[_type]=mp';
    } else {
        window.location =
            `/cart/change?line=${props.lineNumber}` +
            `&properties[_childid]=${props.childid}` +
            `&properties[_amount]=${props.amount}` +
            '&properties[_type]=mp';
    }
}

function addOriginalPropsToURL(props, url) {
    let omittedProps = [
        'type',
        'typeLabel',
        'line',
        'amount',
        'childid',
        'frequency',
        'des_code',
        '_type',
        '_typeLabel',
        '_line',
        '_amount',
        '_childid',
        '_frequency',
        '_des_code',
        'jsType'
    ];
    Object.keys(props).forEach(prop => {
        if (omittedProps.indexOf(prop) === -1) {
            url += `&properties[${prop}]=${props[prop]}`;
        }
    });
    return url;
}

function getProps(event) {
    let cartItem = $(event.target).closest('.basketCard');
    let type = $(event.target).data('type') || cartItem.data('jsType');
    let des_code =
        $(event.target).data('des_code') || cartItem.data('des_code');
    let lineNumber = $(event.target).data('line') || cartItem.data('line');
    let childid = $(event.target).data('childid');
    if (childid === undefined) {
        childid = '';
    } else {
        childid = childid.trim();
    }

    let data = {
        original: cartItem.data(),
        initialFrequency: cartItem.data('frequency'),
        frequency: cartItem.find('.js-frequency').val(),
        initialAmount: cartItem.find('.js-amount').data('initial'),
        amount: cartItem
            .find('.js-amount')
            .val()
            .replace(/\s/g, ''),
        minAmount: cartItem.find('.js-amount').data('minAmount'),
        childid: childid,
        lineNumber,
        type:type,
        des_code,
    };
    return data;
}

// global is expected to be the window object when run in a browser
function remove(global, event) {
    event.preventDefault();

    let sponsorshipLine = parseInt($(event.target).data('line'), 10);
    let topupLine = parseInt($(event.target).data('topupLine'), 10);

    if (topupLine) {
        let first = sponsorshipLine;
        let second = topupLine;

        if (sponsorshipLine > topupLine) {
            first = topupLine;
            second = sponsorshipLine;
        }

        // Due to the fact that the sponsorship and topup must be removed from
        // the cart one at a time in two seperate requests we need to determine
        // which line item comes first and remove that one last (otherwise the
        // line items will shift after the first request completes).
        $.post(
            '/cart/change.js',
            { line: second, quantity: 0 },
            () => {
                $.post(
                    '/cart/change.js',
                    { line: first, quantity: 0 },
                    () => {
                        global.document.location.reload(true);
                    },
                    'json'
                );
            },
            'json'
        );
    } else {
        $.post(
            '/cart/change.js',
            { line: sponsorshipLine, quantity: 0 },
            () => {
                global.document.location.reload(true);
            },
            'json'
        );
    }
}

function removeRecoSection() {
    if ($('.basketCard--suggestionCard').length === 0) {
        $('#reco').remove();
    }
}

function changed(props) {
    if (props.amount !== props.initialAmount) {
        return true;
    } else if (props.frequency !== props.initialFrequency) {
        return true;
    } else {
        return false;
    }
}
